import React, { useState } from 'react';
// import BackupsChart from './Charts/BackupsChart';
import { Form, Select, Tooltip, Typography } from 'antd';
import ClassAChart from './Charts/ClassAChart';
import ClassBChart from './Charts/ClassBChart';
import DownloadsChart from './Charts/DownloadsChart';
import UploadsChart from './Charts/UploadsChart';

const { Title } = Typography;
const { Option } = Select;

interface UsageMetricsChartProps {
  buckets: any[]; // Replace `any[]` with the correct type if you have one
  start: any;
  end: any;
}

const UsageMetricsChart: React.FC<UsageMetricsChartProps> = ({ buckets, start, end }) => {
  const [selectedChart, setSelectedChart] = useState<string>('classA');
  return (
    <div>
      <div className="ChartFilter">
        <Title level={4} className="ant-typography ChartFilter__title truncate">
          Usage Metrics
        </Title>
        <Form layout="vertical">
          <Form.Item label="Select Chart">
            <Select style={{ width: 200 }} value={selectedChart} onChange={(value) => setSelectedChart(value)}>
              <Option value="classA">
                <Tooltip title="Class-A represents Write-only access operations performed on your bucket.">
                  Class-A
                </Tooltip>
              </Option>
              <Option value="classB">
                <Tooltip title="Class-B represents read-only access operations performed on your bucket.">
                  Class-B
                </Tooltip>
              </Option>
              <Option value="downloads">Downloads (Size)</Option>
              <Option value="uploads">Uploads (Size)</Option>
            </Select>
          </Form.Item>
        </Form>
      </div>

      {/* Conditionally render chart based on selected value */}
      {selectedChart === 'classA' && <ClassAChart buckets={buckets} start={start} end={end} />}
      {selectedChart === 'classB' && <ClassBChart buckets={buckets} start={start} end={end} />}
      {selectedChart === 'downloads' && <DownloadsChart buckets={buckets} start={start} end={end} />}
      {selectedChart === 'uploads' && <UploadsChart buckets={buckets} start={start} end={end} />}
      {/* {selectedChart === 'backups' && <BackupsChart />} */}
    </div>
  );
};

export default UsageMetricsChart;
